var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftTriangleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7083153B-6A7D-4CBE-ADA8-8BE3F7FEF279") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-76.000000, -1507.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(76.000000, 1506.350000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22499943,3.9131573 L8.54568801,8.46125054 C8.92607384,8.86165667 8.90984417,9.49461361 8.50943804,9.87499943 C8.32358846,10.0515565 8.07703302,10.15 7.82068858,10.15 L-0.820688578,10.15 C-1.37297333,10.15 -1.82068858,9.70228475 -1.82068858,9.15 C-1.82068858,8.89365556 -1.72224511,8.64710012 -1.54568801,8.46125054 L2.77500057,3.9131573 C3.15538639,3.51275117 3.78834333,3.4965215 4.18874946,3.87690733 C4.20114058,3.88867889 4.21322787,3.90076618 4.22499943,3.9131573 Z",
    id: "Triangle",
    transform: "translate(3.500000, 6.650000) scale(-1, 1) rotate(90.000000) translate(-3.500000, -6.650000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTriangleIcon);
export default __webpack_public_path__ + "static/media/left-triangle-icon.e4ad76138d14a9da3f974118f105d6ca.svg";
export { ForwardRef as ReactComponent };